import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { extractDataProps, extractAriaProps } from '../../../../../../../../util/layout/layoutPropsExtractor.js';
import { mergeProps, mergeRefs } from '@react-aria/utils';
import { useCarouselV3Context } from '../../../../../hooks/useCarouselV3Context.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useNavigationButton = function useNavigationButton(props, externalRef) {
  var ariaLabel = props['aria-label'],
    align = props.align;
  var _useCarouselV3Context = useCarouselV3Context(),
    scrollNext = _useCarouselV3Context.scrollNext,
    scrollPrev = _useCarouselV3Context.scrollPrev,
    canScrollNext = _useCarouselV3Context.canScrollNext,
    canScrollPrev = _useCarouselV3Context.canScrollPrev,
    _useCarouselV3Context2 = _useCarouselV3Context.pageButtons,
    pageButtons = _useCarouselV3Context2 === void 0 ? 'inside' : _useCarouselV3Context2,
    carouselApi = _useCarouselV3Context.carouselApi;
  var internalRef = React.useRef(null);
  var dataProps = extractDataProps(props);
  var ariaProps = extractAriaProps(props);

  // Determine scroll function and state based on alignment
  var scrollFunction = align === 'start' ? scrollPrev : scrollNext;
  var canScroll = align === 'start' ? canScrollPrev : canScrollNext;
  var mergedProps = mergeProps(props, {
    onClick: scrollFunction
  });
  var ref = mergeRefs(internalRef, externalRef);

  // Effect to move focus to carousel container when button becomes disabled and is currently focused
  React.useEffect(function () {
    if (!carouselApi) {
      return undefined;
    }
    var onSelect = function onSelect(e) {
      var currentCanScrollState = align === 'start' ? e.canScrollPrev() : e.canScrollNext();
      var isButtonFocused = internalRef && document.activeElement === internalRef.current;
      if (isButtonFocused && !currentCanScrollState) {
        var carouselContainer = carouselApi.rootNode();
        if (carouselContainer) {
          carouselContainer.focus();
        }
      }
    };
    carouselApi.on('select', onSelect);
    return function () {
      carouselApi.off('select', onSelect);
    };
  }, [carouselApi, align]);
  var navigatorProps = {
    acceptPointer: true,
    accessibilityLabel: ariaLabel,
    align: align,
    attributes: _objectSpread(_objectSpread({}, dataProps), ariaProps),
    disabled: !canScroll,
    size: 'm',
    onClick: mergedProps.onClick,
    variant: pageButtons,
    visible: canScroll,
    zIndex: 1,
    width: '52px',
    ref: ref
  };
  return {
    navigatorProps: navigatorProps
  };
};

export { useNavigationButton };
//# sourceMappingURL=useNavigationButton.js.map
